(function () {
  'use strict';

  var CACHE_PREFIX = 'tuk-offers-collection-v1:';
  var MAX_COLLECTION_PAGES = 10;

  function collectionUrl(handle, page) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page;
  }

  function readCache(handle) {
    try {
      var cached = window.sessionStorage.getItem(CACHE_PREFIX + handle);
      return cached ? JSON.parse(cached) : null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(handle, handles) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify(handles));
    } catch (error) {
      // The feature continues without storage when it is unavailable.
    }
  }

  async function fetchCollectionHandles(handle) {
    var cached = readCache(handle);
    if (cached) return new Set(cached);

    var handles = [];
    for (var page = 1; page <= MAX_COLLECTION_PAGES; page += 1) {
      var response = await fetch(collectionUrl(handle, page), {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Unable to load collection ' + handle);

      var payload = await response.json();
      var products = payload && Array.isArray(payload.products) ? payload.products : [];
      products.forEach(function (product) {
        if (product && product.handle) handles.push(product.handle);
      });
      if (products.length < 250) break;
    }

    writeCache(handle, handles);
    return new Set(handles);
  }

  function productHandle(card) {
    var link = card.querySelector('figure a[href*="/products/"], a[href*="/products/"]');
    if (!link) return '';
    try {
      var parts = new URL(link.href, window.location.origin).pathname.split('/products/');
      return parts[1] ? parts[1].split('/')[0] : '';
    } catch (error) {
      return '';
    }
  }

  function initialise(section) {
    if (section.dataset.offersCategoriesInitialised === 'true') return;
    section.dataset.offersCategoriesInitialised = 'true';

    var offersHandle = section.dataset.offersHandle;
    var paramName = section.dataset.filterParam || 'tuk_offer_category';
    var exclusiveRanges = section.dataset.exclusiveRanges === 'true';
    var pageSize = Number(section.dataset.pageSize) || 12;
    var totalProducts = Number(section.dataset.totalProducts) || 0;
    var items = Array.from(section.querySelectorAll('[data-offers-category-item]'));
    var clearButton = section.querySelector('[data-offers-category-clear]');
    var track = section.querySelector('[data-offers-category-track]');
    var previous = section.querySelector('[data-offers-category-previous]');
    var next = section.querySelector('[data-offers-category-next]');
    var categorySets = new Map();
    var categoryCounts = new Map();
    var allCardsLoaded = false;
    var loadingAllCards;
    var replacingGrid = false;
    var activeHandle = new URLSearchParams(window.location.search).get(paramName) || '';

    function activeItem() {
      return items.find(function (item) {
        return item.dataset.categoryHandle === activeHandle;
      });
    }

    function syncFilterInput() {
      var form = document.getElementById('filter');
      if (!form) return;
      var input = form.querySelector('input[name="' + paramName + '"]');
      if (!activeHandle) {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = paramName;
        form.appendChild(input);
      }
      input.value = activeHandle;
    }

    function updateUrl(resetPage) {
      var url = new URL(window.location.href);
      if (resetPage) url.searchParams.delete('page');
      if (activeHandle) url.searchParams.set(paramName, activeHandle);
      else url.searchParams.delete(paramName);
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    function updateButtons() {
      items.forEach(function (item) {
        var selected = item.dataset.categoryHandle === activeHandle;
        var button = item.querySelector('[data-offers-category-button]');
        if (button) button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (clearButton) clearButton.setAttribute('aria-pressed', activeHandle ? 'false' : 'true');
    }

    function visibleCards() {
      return Array.from(document.querySelectorAll('#collection > li')).filter(function (card) {
        return !card.hasAttribute('data-tuk-category-hidden');
      });
    }

    function updateProductCount(count) {
      document.querySelectorAll('.f8sr .hx').forEach(function (element) {
        element.textContent = count === 1 ? '1 product' : count + ' products';
      });
    }

    function scrollToProductSummary() {
      var grid = document.getElementById('collection');
      var collectionSection = grid ? grid.closest('[id^="shopify-section-"]') : null;
      var summary = collectionSection ? collectionSection.querySelector('.f8sr') : document.querySelector('.f8sr');
      var target = summary || grid;
      if (!target) return;

      var rootStyles = getComputedStyle(document.documentElement);
      var stickyOffset = parseFloat(rootStyles.getPropertyValue('--sticky_offset')) || 0;
      var spacing = parseFloat(rootStyles.getPropertyValue('--rpp')) || 16;
      var top = target.getBoundingClientRect().top + window.scrollY - stickyOffset - spacing;

      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function pageUrl(page) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', page);
      url.searchParams.delete(paramName);
      return url.toString();
    }

    function refreshProductCardBehaviour() {
      ['semanticInput', 'listScrollable', 'productVariants', 'semanticSelect', 'check-limit-event', 'ratings', 'schemeTooltip', 'popups', 'formZindex'].forEach(function (eventName) {
        window.dispatchEvent(new CustomEvent(eventName));
      });
      if (window.ajaxCart && typeof window.ajaxCart.init === 'function') window.ajaxCart.init();
      if (window.quickShop && typeof window.quickShop.init === 'function') window.quickShop.init();
    }

    function ensureAllCards() {
      if (allCardsLoaded) return Promise.resolve();
      if (loadingAllCards) return loadingAllCards;

      var grid = document.getElementById('collection');
      if (!grid) return Promise.resolve();

      var pages = Math.max(1, Math.ceil(totalProducts / pageSize));
      var requests = [];
      for (var page = 1; page <= pages; page += 1) {
        requests.push(fetch(pageUrl(page)).then(function (response) {
          if (!response.ok) throw new Error('Unable to prepare collection products');
          return response.text();
        }));
      }

      document.body.classList.add('tuk-offers-filtering');
      loadingAllCards = Promise.all(requests).then(function (pagesMarkup) {
        var cardsByHandle = new Map();
        pagesMarkup.forEach(function (markup) {
          var documentPage = new DOMParser().parseFromString(markup, 'text/html');
          documentPage.querySelectorAll('#collection > li').forEach(function (card) {
            var handle = productHandle(card);
            if (handle && !cardsByHandle.has(handle)) cardsByHandle.set(handle, card);
          });
        });

        replacingGrid = true;
        grid.replaceChildren.apply(grid, Array.from(cardsByHandle.values()));
        replacingGrid = false;
        allCardsLoaded = true;
        refreshProductCardBehaviour();
      }).finally(function () {
        document.body.classList.remove('tuk-offers-filtering');
        loadingAllCards = null;
      });

      return loadingAllCards;
    }

    function applyGridFilter() {
      updateUrl(false);
      syncFilterInput();
      updateButtons();

      var cards = Array.from(document.querySelectorAll('#collection > li'));
      if (!activeHandle) {
        cards.forEach(function (card) {
          card.removeAttribute('data-tuk-category-hidden');
        });
        document.body.classList.remove('tuk-offers-category-active');
        updateProductCount(allCardsLoaded ? cards.length : totalProducts);
        return;
      }

      var handles = categorySets.get(activeHandle);
      if (!handles) return;

      var loadedHandles = new Set();
      var displayedHandles = new Set();
      cards.forEach(function (card) {
        var handle = productHandle(card);
        if (handle && loadedHandles.has(handle)) {
          card.remove();
          return;
        }
        if (handle) loadedHandles.add(handle);
        if (handles.has(handle) && !displayedHandles.has(handle)) {
          displayedHandles.add(handle);
          card.removeAttribute('data-tuk-category-hidden');
        } else {
          card.setAttribute('data-tuk-category-hidden', 'true');
        }
      });

      document.body.classList.add('tuk-offers-category-active');
      updateProductCount(visibleCards().length);
    }

    async function selectCategory(handle, scrollToProducts) {
      activeHandle = handle || '';
      updateUrl(true);
      updateButtons();

      if (activeHandle) await ensureAllCards();
      applyGridFilter();

      if (scrollToProducts) {
        scrollToProductSummary();
      }
    }

    items.forEach(function (item) {
      var button = item.querySelector('[data-offers-category-button]');
      if (!button) return;
      button.addEventListener('click', function () {
        selectCategory(item.dataset.categoryHandle, true);
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        selectCategory('', true);
      });
    }

    function scrollTrack(direction) {
      if (!track) return;
      track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.75), behavior: 'smooth' });
    }

    function updateArrowState() {
      if (!track) return;
      var maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.hidden = track.scrollLeft <= 1;
      if (next) next.hidden = track.scrollLeft >= maximumScroll - 1;
    }

    if (previous) previous.addEventListener('click', function () { scrollTrack(-1); });
    if (next) next.addEventListener('click', function () { scrollTrack(1); });
    if (track) track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    window.requestAnimationFrame(updateArrowState);

    var mutationTimer;
    var gridObserver = new MutationObserver(function () {
      if (replacingGrid) return;
      window.clearTimeout(mutationTimer);
      mutationTimer = window.setTimeout(function () {
        applyGridFilter();
      }, 50);
    });
    var gridElement = document.getElementById('collection');
    var collectionSection = gridElement ? gridElement.closest('[id^="shopify-section-"]') : null;
    if (collectionSection) gridObserver.observe(collectionSection, { childList: true, subtree: true });

    window.addEventListener('collectionLoadMore', function () {
      window.setTimeout(function () {
        applyGridFilter();
      }, 60);
    });
    window.addEventListener('initFilters', function () {
      allCardsLoaded = false;
      window.setTimeout(function () {
        if (activeHandle) ensureAllCards().then(applyGridFilter);
        else applyGridFilter();
      }, 60);
    });
    window.addEventListener('popstate', function () {
      activeHandle = new URLSearchParams(window.location.search).get(paramName) || '';
      if (activeHandle) ensureAllCards().then(applyGridFilter);
      else applyGridFilter();
    });

    Promise.all([
      fetchCollectionHandles(offersHandle),
      Promise.all(items.map(function (item) {
        return fetchCollectionHandles(item.dataset.categoryHandle);
      }))
    ]).then(function (results) {
      var offerHandles = results[0];
      var parentSets = results[1];
      var previousRangeHandles = new Set();

      items.forEach(function (item, index) {
        var handle = item.dataset.categoryHandle;
        var intersection = new Set();
        parentSets[index].forEach(function (productHandleValue) {
          if (!offerHandles.has(productHandleValue)) return;
          if (!exclusiveRanges || !previousRangeHandles.has(productHandleValue)) {
            intersection.add(productHandleValue);
          }
        });
        if (exclusiveRanges) {
          parentSets[index].forEach(function (productHandleValue) {
            if (offerHandles.has(productHandleValue)) previousRangeHandles.add(productHandleValue);
          });
        }
        categorySets.set(handle, intersection);
        categoryCounts.set(handle, intersection.size);
        item.hidden = intersection.size === 0;
      });

      updateArrowState();

      if (activeHandle && !categorySets.has(activeHandle)) activeHandle = '';
      updateUrl(false);
      if (activeHandle) ensureAllCards().then(applyGridFilter);
      else applyGridFilter();
    }).catch(function (error) {
      console.warn('Collection category filter:', error);
      activeHandle = '';
      updateButtons();
      syncFilterInput();
    });

    syncFilterInput();
    updateButtons();
  }

  function initialiseAll() {
    document.querySelectorAll('[data-tuk-offers-categories]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
